import React,{Fragment} from 'react';
import './App.css';
// import  { Rates } from "rate-quotes";
import { Rates } from "rate-quotes";

function App() {

  return (
    <Fragment>
      <Rates leadSource="BLCHMWEB" />
    </Fragment>
  );
}

export default App;

